import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsaFileUploadComponent } from './components/bsa-file-upload/bsa-file-upload.component';
import { BsaScenarioInfoFormComponent } from './components/bsa-scenario-info-form/bsa-scenario-info-form.component';
import { BsaWholesaleComponent } from './components/bsa-wholesale/bsa-wholesale.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    BsaScenarioInfoFormComponent,
    BsaFileUploadComponent,
    BsaWholesaleComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule
  ],
  exports: [
    BsaScenarioInfoFormComponent,
    BsaFileUploadComponent,
    BsaWholesaleComponent,
  ]
})
export class BsaModule { }
